'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * Find a Slate node from a DOM `element`.
 *
 * @param {Element} element
 * @param {Value} value
 * @return {Node|Null}
 */

function findNode(element, value) {
  var closest = element.closest('[data-key]');
  if (!closest) return null;

  var key = closest.getAttribute('data-key');
  if (!key) return null;

  var node = value.document.getNode(key);
  return node || null;
}

/**
 * Export.
 *
 * @type {Function}
 */

exports.default = findNode;


//////////////////
// WEBPACK FOOTER
// ../node_modules/slate-react/lib/utils/find-node.js
// module id = 160
// module chunks = 0